import React, {useCallback, useEffect} from 'react'
import {shallowEqual} from 'react-redux'
import {Link} from 'react-router-dom'
import {Box, Toolbar, Typography} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'
import {useTranslation} from 'react-i18next'
import {toggleDrawer} from 'store/actions/sidebar'
import CloseIcon from '@material-ui/icons/Close'
import MenuIcon from '@material-ui/icons/Menu'
import {CHANGE_LANGUAGE} from 'store/actions/account'
import {selectHeaderData} from 'store/selectors'
import SelectControl from 'components/SelectControl/SelectControl'
import {ReactComponent as LogoSvg} from 'assets/logo.svg'
import {useAppSelector, useAppDispatch} from 'store/redux'
import useStyles from './styles'

const languageList = [
  {
    value: 'uk',
    text: 'УКР',
  },
  {
    value: 'en',
    text: 'ENG',
  },
]

const Header: React.FC = () => {
  const classes = useStyles()
  const {i18n} = useTranslation()

  const dispatch = useAppDispatch()

  const isOpenSidebar = useAppSelector(state => state.sidebar.open)

  const {
    roleId,
    userName,
    hasAccess,
    handleLogout,
    language: defaultLanguage,
  } = useAppSelector(selectHeaderData, shallowEqual)

  useEffect(() => {
    i18n.changeLanguage(defaultLanguage)
  }, [defaultLanguage, i18n])

  const handleChangeLanguage = useCallback(
    ({target: {value}}: React.ChangeEvent<{value: unknown}>) => {
      localStorage.setItem('language', JSON.stringify(value))
      dispatch({
        type: CHANGE_LANGUAGE,
        data: value,
      })
    },
    [dispatch],
  )

  const isEnabledDrawer = hasAccess && roleId

  const openDrawer = () => {
    if (isEnabledDrawer) {
      dispatch(toggleDrawer(true))
    }
  }
  const closeDrawer = () => {
    dispatch(toggleDrawer(false))
  }

  return (
    <Toolbar className={classes.root}>
      <Box className={classes.toolbar}>
        {isOpenSidebar ? (
          <IconButton onClick={closeDrawer}>
            <CloseIcon />
          </IconButton>
        ) : (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={openDrawer}
            disabled={!isEnabledDrawer}
          >
            <MenuIcon />
          </IconButton>
        )}
      </Box>
      <Link className={classes.logoContainer} to="/">
        <LogoSvg />
        <Typography className={classes.title} variant="subtitle1" noWrap>
          WatchTower
        </Typography>
      </Link>
      <Grid
        className={classes.accountBlock}
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <SelectControl
          items={languageList}
          selectedItem={defaultLanguage}
          variant="standard"
          onHandleChange={handleChangeLanguage}
          title=""
        />
        <Box className={classes.user}>{userName}</Box>
        <AccountCircleOutlinedIcon className="iconAccount" />
        <IconButton
          className="logout"
          aria-label="logout"
          onClick={() => {
            if (handleLogout) {
              handleLogout()
            }
          }}
        >
          <PowerSettingsNewIcon />
        </IconButton>
      </Grid>
    </Toolbar>
  )
}

export default Header
